const groupMessage = {
  groupError: 'Error retrieving groups.',
  createGroupSuccess: 'Group successfully created.',
  updateGroupSuccess: 'Group successfully updated.',
  deleteGroupSuccess: 'Group successfully deleted.'
}

export default groupMessage;